<template>
	<div class="brick">
		<div class="list_top_box">
			<div class="left_option">
				<em class="lt_text">App Date</em>
				<span class="mgr_5"> <CustomDatePicker v-model="app_date_from"/> ~ <CustomDatePicker v-model="app_date_to"/></span>

				<em class="lt_text">Received Date</em>
				<span class="mgr_5"> <CustomDatePicker v-model="received_date_from"/> ~ <CustomDatePicker v-model="received_date_to"/></span>

				<span class="int_type_no_border mgr_5">
					<PartnerSelect v-model="vendor_code" ph="Vendor Code" :showName="false" :vendorOnly="true" @set-partner="setPartner" />
				</span>

				<span class="int_type mgr_15">
					<select v-model="closed_yn" class="tbl_select sm_int">
						<option v-for="tag in this.$closedTags" v-bind:value="tag.value" v-bind:key="tag.value">{{ tag.text }}</option>
					</select>
				</span>
				<span class="int_type mgr_15">
					<select v-model="received_yn" class="tbl_select sm_int">
						<option v-for="tag in this.$receivedTags" v-bind:value="tag.value" v-bind:key="tag.value">{{ tag.text }}</option>
					</select>
				</span>
				<span v-if="user.company_id == 'hairplus'" class="int_type mgr_15">
					<select v-model="payment_status" class="tbl_select sm_int" @change="search()">
						<option v-for="tag in this.$paymentStatusTags" v-bind:value="tag.value" v-bind:key="tag.value">{{ tag.text }}</option>
					</select>
				</span>
				<span v-if="user.company_id == 'hairplus'" class="int_type mgr_15">
					<select v-model="cbp_duty_status" class="tbl_select sm_int" @change="search()">
						<option v-for="tag in this.$cbpStatusTags" v-bind:value="tag.value" v-bind:key="tag.value">{{ tag.text }}</option>
					</select>
				</span>
				<span v-if="user.company_id == 'hairplus'" class="int_type mgr_15">
					<select v-model="shipping_cost_status" class="tbl_select sm_int" @change="search()">
						<option v-for="tag in this.$shippingStatusTags" v-bind:value="tag.value" v-bind:key="tag.value">{{ tag.text }}</option>
					</select>
				</span>
			</div>
			<div class="left_option">
				<em class="lt_text">Item {{ headers.class }}</em>
				<span class="int_type_no_border mgr_5"> <ItemClassSelect v-model="itemClass" :showName="true" /> </span>

				<span class="int_type sm_int mgr_15">
					<input type="text" v-model.trim="keyword" placeholder="Enter Search Keyword" autofocus autocomplete="off" @keyup.enter="search()" />
				</span>

				<em class="lt_text">Carton</em>
				<span class="int_type mgr_5">
					<input type="text" v-model.trim="carton_from" placeholder="Min" autocomplete="off" style="width:50px;text-align:right;" @keyup.enter="search()" />
				</span>
				~
				<span class="int_type mgr_15">
					<input type="text" v-model.trim="carton_to" placeholder="Max" autocomplete="off" style="width:50px;text-align:right;" @keyup.enter="search()" />
				</span>

				<template v-if="user.company_id == 'hairplus'">
					<em class="lt_text">Landed Cost</em>
					<span class="int_type mgr_5">
						<input type="text" v-model.trim="landed_cost_from" placeholder="Min" autocomplete="off" style="width:80px;text-align:right;" @keyup.enter="search()" />
					</span>
					~
					<span class="int_type mgr_15">
						<input type="text" v-model.trim="landed_cost_to" placeholder="Max" autocomplete="off" style="width:80px;text-align:right;" @keyup.enter="search()" />
					</span>
				</template>

				<a href="javascript:;" class="search_bt" @click="search()">Search</a>
				<a href="javascript:;" class="gray_bt" @click="reset()">Reset</a>
			</div>
		</div>

		<table class="list_tbl" v-columns-resizable border="0">
			<thead>
				<tr>
					<th width="20px;"><input type="checkbox" @change="allClick" v-model="checked" /></th>
					<th width="80px;">
						<a href="javascript:;" @click="sort('sh_dn')">Sh No{{ sortMark('sh_dn') }}</a>
					</th>
					<th width="90px;">
						<a href="javascript:;" @click="sort('application_date')">App Date{{ sortMark('application_date') }}</a>
					</th>
					<th width="80px;">
						<a href="javascript:;" @click="sort('vendor_code')">Vendor Code{{ sortMark('vendor_code') }}</a>
					</th>
					<th v-if="user.company_id != 'newjigu'" width="100px;">LC No</th>
					<th width="90px;">
						<a href="javascript:;" @click="sort('ship_date')">Ship Date{{ sortMark('ship_date') }}</a>
					</th>
					<th width="185px;">
						<a href="javascript:;" @click="sort('arrival_date')">Arr. / ETA Date{{ sortMark('arrival_date') }}</a>
					</th>
					<th v-if="user.company_id != 'hairplus'" width="175px;">
						<a href="javascript:;" @click="sort('status')">Status{{ sortMark('status') }}</a>
					</th>
					<th width="55px;">
						<a href="javascript:;" @click="sort('carton')">Carton{{ sortMark('carton') }}</a>
					</th>
					<th width="55px;">Quantity</th>
					<th width="80px;">Amount</th>
					<th width="90px;">
						<a href="javascript:;" @click="sort('received_date')">Rcvd Date{{ sortMark('received_date') }}</a>
					</th>
					<th v-if="user.company_id == 'hairplus'" width="55px;">
						<a href="javascript:;" @click="sort('closed_yn')">Closed{{ sortMark('closed_yn') }}</a>
					</th>
					<th v-if="user.company_id != 'newjigu'" width="55px;">
						<a href="javascript:;" @click="sort('received_quantity')">Rcvd Qty{{ sortMark('received_quantity') }}</a>
					</th>
					<th v-if="user.company_id != 'newjigu'" width="90px;">Rcvd Amt</th>
					<th v-if="user.company_id == 'hairplus'" width="175px;">
						<a href="javascript:;" @click="sort('status')">Status{{ sortMark('status') }}</a>
					</th>
					<th v-if="user.company_id != 'newjigu' && user.company_id != 'hairplus'" width="130px;">
						<a href="javascript:;" @click="sort('vendor_name')">Vendor Name{{ sortMark('vendor_name') }}</a>
					</th>
					<th v-if="user.company_id == 'newjigu'" idth="200px;">{{ headers.class }} Code</th>
					<th v-if="user.company_id == 'newjigu'" idth="180px;">PO #s</th>
					<th v-if="user.company_id != 'hairplus'" width="55px;">
						<a href="javascript:;" @click="sort('closed_yn')">Closed{{ sortMark('closed_yn') }}</a>
					</th>
					<th v-if="user.company_id == 'hairplus'" width="210px;">
						<a href="javascript:;" @click="sort('cbp_duty')">CBP Tariff{{ sortMark('cbp_duty') }}</a>
					</th>
					<th v-if="user.company_id == 'hairplus'" width="150px;">
						<a href="javascript:;" @click="sort('shipping_cost')">Shipping Cost{{ sortMark('shipping_cost') }}</a>
					</th>
					<th v-if="user.company_id == 'hairplus'" width="100px;" style="font-weight:bold;">Landed Cost</th>
					<th v-if="user.company_id == 'arkin'" width="130px;">PO No</th>
					<th v-if="user.company_id != 'arkin'">Description</th>
					<!-- <th width="5%">Closed</th> -->
				</tr>
			</thead>
			<tbody>
				<tr v-for="shipment in shipments" v-bind:key="shipment.sh_no">
					<td class="al_center">
						<input type="checkbox" v-model="selected_sh_no" :value="shipment.sh_no" />
					</td>
					<td class="al_left">
						<a href="javascript:;" @click="selectShipment(shipment)">{{ shipment.sh_dn }}</a> <small v-if="user.company_id == 'hairplus'">{{ shipment.price_basis == 'FOB' ? 'FOB' : 'COST' }}</small>
					</td>
					<td class="al_left">{{ shipment.application_date }}</td>
					<td class="al_left">{{ shipment.vendor_code }}</td>
					<td v-if="user.company_id != 'newjigu'" class="al_left">{{ shipment.lc_no }}</td>
					<td class="al_left">{{ shipment.shipment_date }}</td>
					<td class="al_left nowrap_cell"><CustomDatePicker v-model="shipment.arrival_date" /><a href="javascript:;" :class="modifiable ? 'gray_bt2' : 'gray_bt2 disable_bt'" @click="updateArrivalDate(shipment)">Update</a></td>
					<td v-if="user.company_id != 'hairplus'" class="al_left nowrap_cell">
						<input type="text" class="tbl_int" style="width:100px;" v-model.trim="shipment.status" /><a href="javascript:;" :class="modifiable ? 'gray_bt2' : 'gray_bt2 disable_bt'" @click="updateStatus(shipment)">Update</a>
					</td>
					<td class="al_right">{{ shipment.carton | commaSeparated }}</td>
					<td class="al_right">{{ shipment.total_quantity | commaSeparated }}</td>
					<td class="al_right">{{ shipment.total_amount | toCurrency }}</td>
					<td class="al_left">{{ shipment.received_date }}</td>
					<td v-if="user.company_id == 'hairplus'" class="al_center">{{ shipment.closed_yn == 'Y' ? 'Closed' : 'Active' }}</td>
					<td v-if="user.company_id != 'newjigu'" class="al_right">{{ shipment.received_quantity | commaSeparated }}</td>
					<td v-if="user.company_id != 'newjigu'" class="al_right">{{ shipment.received_amount | toCurrency }}</td>
					<td v-if="user.company_id == 'hairplus'" class="al_left">
						<select v-model="shipment.payment_sel" class="tbl_select" :class="{ red_sel: shipment.payment_sel == 'UNPAID' || shipment.payment_sel == 'OTHERS' }" style="width:80px;">
							<option value="">-</option>
							<option value="PAID">지급 완료</option>
							<option value="UNPAID">미지급</option>
							<option value="OTHERS">Others</option>
						</select>
						<a href="javascript:;" :class="modifiable ? 'gray_bt2' : 'gray_bt2 disable_bt'" @click="updateStatus(shipment)">Update</a>
						<div style="margin-top:4px;">
							<input type="text" class="tbl_int" style="width:135px;" v-model.trim="shipment.payment_memo" placeholder="Memo" />
						</div>
					</td>
					<td v-if="user.company_id != 'newjigu' && user.company_id != 'hairplus'" class="al_left truncate" :title="shipment.vendor_name">
						<a href="javascript:;" @click="gotoPartner(shipment.vendor_code)">{{ shipment.vendor_name }}</a>
					</td>
					<td v-if="user.company_id == 'newjigu'" class="al_left truncate" :title="shipment.classes">{{ shipment.classes }}</td>
					<td v-if="user.company_id == 'newjigu'" class="al_left truncate" :title="shipment.pos">{{ shipment.pos }}</td>
					<td v-if="user.company_id != 'hairplus'" class="al_center">{{ shipment.closed_yn == 'Y' ? 'Closed' : 'Active' }}</td>
					<td v-if="user.company_id == 'hairplus'" class="al_left cbp_cell">
						<currency-input class="tbl_int" style="width:55px;text-align:right;" v-model="shipment.cbp_duty" />
						<select v-model="shipment.cbp_duty_sel" class="tbl_select" :class="{ red_sel: shipment.cbp_duty_sel == 'OTHERS' }" style="width:65px;">
							<option value="">-</option>
							<option value="COMPLETED">완료</option>
							<option value="OTHERS">Others</option>
						</select>
						<a href="javascript:;" :class="modifiable ? 'gray_bt2' : 'gray_bt2 disable_bt'" @click="updateCbpDuty(shipment)">Update</a>
						<div style="margin-top:4px;">
							<input type="text" class="tbl_int" style="width:135px;" v-model.trim="shipment.cbp_duty_memo" placeholder="Memo" />
						</div>
					</td>
					<td v-if="user.company_id == 'hairplus'" class="al_left cbp_cell">
						<currency-input class="tbl_int" style="width:55px;text-align:right;" v-model="shipment.shipping_cost" />
						<select v-model="shipment.shipping_cost_sel" class="tbl_select" :class="{ red_sel: shipment.shipping_cost_sel == 'UNPAID' || shipment.shipping_cost_sel == 'OTHERS' }" style="width:65px;">
							<option value="">-</option>
							<option value="COMPLETED">완료</option>
							<option value="UNPAID">미지급</option>
							<option value="OTHERS">Others</option>
						</select>
						<a href="javascript:;" :class="modifiable ? 'gray_bt2' : 'gray_bt2 disable_bt'" @click="updateShippingCost(shipment)">Update</a>
						<div style="margin-top:4px;">
							<input type="text" class="tbl_int" style="width:135px;" v-model.trim="shipment.shipping_cost_memo" placeholder="Memo" />
						</div>
					</td>
					<td v-if="user.company_id == 'hairplus'" class="al_right" style="font-weight:bold;">{{ landedCost(shipment) | toCurrency }}</td>
					<td v-if="user.company_id == 'arkin'" class="al_left truncate" :title="shipment.pos">{{ shipment.pos }}</td>
					<td v-if="user.company_id != 'arkin'" class="al_left" :title="shipment.description">
						<div class="desc_clamp">{{ shipment.description }}</div>
					</td>
					<!-- <td class="al_center">{{ shipment.closed_yn == 'Y' ? 'Closed' : 'Active' }}</td> -->
				</tr>
				<tr v-if="user.company_id == 'hairplus'">
					<td colspan="8" class="al_right"><font color="red">Total</font></td>
					<td class="al_right">
						<font color="red">{{ shipments_sum.total_quantity | commaSeparated }}</font>
					</td>
					<td class="al_right">
						<font color="red">{{ shipments_sum.total_amount | toCurrency }}</font>
					</td>
					<td></td>
					<td></td>
					<td class="al_right">
						<font color="red">{{ shipments_sum.received_quantity | commaSeparated }}</font>
					</td>
					<td class="al_right">
						<font color="red">{{ shipments_sum.received_amount | toCurrency }}</font>
					</td>
					<td></td>
					<td class="al_right">
						<font color="red">{{ shipments_sum.cbp_duty | toCurrency }}</font>
					</td>
					<td class="al_right">
						<font color="red">{{ shipments_sum.shipping_cost | toCurrency }}</font>
					</td>
					<td class="al_right" style="font-weight:bold;">
						<font color="red">{{ landedCostSumTotal | toCurrency }}</font>
					</td>
					<td></td>
				</tr>
				<tr v-if="user.company_id != 'hairplus'">
					<td :colspan="user.company_id == 'newjigu' ? 8 : 9" class="al_right"><font color="red">Total</font></td>
					<td class="al_right">
						<font color="red">{{ shipments_sum.total_quantity | commaSeparated }}</font>
					</td>
					<td class="al_right">
						<font color="red">{{ shipments_sum.total_amount | toCurrency }}</font>
					</td>
					<td></td>
					<td v-if="user.company_id != 'newjigu'" class="al_right">
						<font color="red">{{ shipments_sum.received_quantity | commaSeparated }}</font>
					</td>
					<td v-if="user.company_id != 'newjigu'" class="al_right">
						<font color="red">{{ shipments_sum.received_amount | toCurrency }}</font>
					</td>
					<td :colspan="user.company_id == 'newjigu' ? 4 : 3"></td>
					<!-- <td></td> -->
				</tr>
			</tbody>
		</table>
		<div style="text-align:right;padding-right:10px;">Total Count : {{ shipments_sum.list_count | commaSeparated }}</div>

		<Paging ref="paging" v-on:gotoPage="gotoPage"></Paging>

		<div class="bottom_bt_box">
			<ul>
				<li class="mgr_15"><PageSizeSelect v-model="page_size" @input="search()" /></li>
				<li class="mgr_10"><a href="javascript:void(0);" v-on:click="excelList">Excel</a></li>
				<li v-if="user.company_id == 'jc'" class="mgr_10"><a href="javascript:void(0);" @click="sheet()">Sheet</a></li>
				<li v-if="selected_sh_no.length > 0" class="mgr_10"><a href="javascript:void(0);" v-on:click="excel">Excel Export of Selected Shipment Items(s)</a></li>
				<li v-if="modifiable && selected_sh_no.length > 0" class="mgr_10"><a href="javascript:void(0);" v-on:click="updateClosedYnBatch('Y')">Close Selected Shipment(s)</a></li>
				<li v-if="modifiable && selected_sh_no.length > 0" class="mgr_10"><a href="javascript:void(0);" v-on:click="updateClosedYnBatch('N')">Activate Selected Shipment(s)</a></li>
				<li v-if="modifiable"><router-link :to="{ name: 'shipmentDetail', params: { mode: 'add' }, query: { backUri: this.uri } }">Add</router-link></li>
			</ul>
		</div>

		<table class="list_tbl mgb_0 add_top_line" v-show="false" id="exportTable">
			<thead>
				<tr>
					<th width="2%">No</th>
					<th width="10%">Class</th>
					<th>Name</th>
					<th width="7%">Color</th>
					<th width="6%">Price</th>
					<th width="5%">Qty</th>
					<th width="7%">Amount</th>
					<th width="5%">Rcvd Qty</th>
					<th width="6%">Rcvd Amt</th>
					<th width="7%">PO No</th>
					<th width="5%">PO Price</th>
					<th width="5%">PO Qty</th>
					<th width="7%">PO Amount</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(item, index) in excelItems" v-bind:key="item.sh_item_no">
					<td class="al_left">{{ index + 1 }}</td>
					<td class="al_left">{{ item.class_code }}</td>
					<td class="al_left">{{ item.name }}</td>
					<td class="al_left">{{ item.color_code }}</td>
					<td class="al_right">{{ item.unit_price }}</td>
					<td class="al_right">{{ item.quantity }}</td>
					<td class="al_right">{{ item.amount }}</td>
					<td class="al_right">{{ item.received_quantity }}</td>

					<td class="al_right">{{ item.received_amount }}</td>
					<td class="al_left">{{ item.po_dn }}</td>
					<td class="al_right">{{ item.po_unit_price }}</td>
					<td class="al_right">{{ item.po_quantity }}</td>
					<td class="al_right">{{ item.po_amount }}</td>
				</tr>
			</tbody>
		</table>

		<SheetCopyPopup v-if="sheet_popup" :sheet="sheet_popup" @close="sheet_popup = null" />
	</div>
</template>

<script>
import { daysAgo, today } from '@/utils/date';
import Paging from '@/components/common/Paging';
import PageSizeSelect from '@/components/common/PageSizeSelect';
import CustomDatePicker from '@/components/common/CustomDatePicker.vue';
import PartnerSelect from '@/components/common/PartnerSelect';
import ItemClassSelect from '@/components/common/ItemClassSelect';
import { inputSelectOnClick } from '@/utils/etc.js';
import { apiFindShipmentList, apiSelectShipmentList, apiUpdateShipmentArrivalDate, apiUpdateShipmentCbpDuty, apiUpdateShipmentClosedYnBatch, apiUpdateShipmentShippingCost, apiUpdateShipmentStatus } from '@/api/purchase/shipment.js';
import { apiGetReportTemplate, exportDataExcel, exportFile, objectToFormData, Report, reportMrtUrl } from '@/api/util';
import { defaultDataType } from 'export-xlsx';
import SheetCopyPopup from '@/components/common/SheetCopyPopup';
import { sumColumn } from '@/utils/sheetCopy';

export default {
	props: ['headers'],
	data: function() {
		return {
			uri: null,
			backUri: '/',
			paging_yn: 'Y',
			page_size: 0,
			page_no: 1,
			//list_count: 0,

			sort_key: 'application_date',
			sort_direction: 'DESC',

			received_date_from: null,
			received_date_to: null,
			app_date_from: daysAgo(6),
			app_date_to: today(),
			vendor_code: null,
			//closed_yn: 'A',
			closed_yn: 'N',
			received_yn: 'A',
			payment_status: 'A',
			cbp_duty_status: 'A',
			shipping_cost_status: 'A',
			itemClass: null,
			keyword: null,
			carton_from: null,
			carton_to: null,
			landed_cost_from: null,
			landed_cost_to: null,

			shipments: [],

			shipments_sum: {},

			excelItems: [],

			modalName: '',
			showModal: false,

			selected_sh_no: [],
			checked: false,

			// #3312 마지막 성공 검색 조건(정렬 포함, paging 제외)과 Sheet 팝업
			sheet_param: null,
			sheet_popup: null,
		};
	},
	computed: {
		modifiable() {
			var menus = this.$session.get('menus');
			for (var i = 0; i < menus.length; i++) {
				// if (menus[i].path == this.$router.history.current.path && menus[i].modify_yn == 'Y') return true;
				if ((menus[i].path == this.$router.history.current.path || menus[i].path == this.$router.history.current.path.replace('add', 'detail')) && menus[i].modify_yn == 'Y') return true;
			}
			return false;
		},
		user: function() {
			return this.$session.get('user');
		},
		landedCostSumTotal: function() {
			var s = this.shipments_sum || {};
			var a = Number(s.received_amount) || 0;
			var b = Number(s.cbp_duty) || 0;
			var c = Number(s.shipping_cost) || 0;
			return a + b + c;
		},
	},
	components: {
		CustomDatePicker,
		Paging,
		PageSizeSelect,
		PartnerSelect,
		ItemClassSelect,
		SheetCopyPopup,
	},
	methods: {
		paymentStatusLabel(status, memo) {
			if (!status) return memo || '';
			if (status == 'PAID') return memo ? '지급완료: ' + memo : '지급완료';
			if (status == 'UNPAID') return memo ? '미지급: ' + memo : '미지급';
			if (status.indexOf('OTHERS') == 0) {
				var m = memo || (status.length > 7 ? status.substring(7) : '');
				return m ? 'Others: ' + m : 'Others';
			}
			return memo ? status + ': ' + memo : status;
		},
		statusMemoLabel(status, memo) {
			var m = memo || (status && status.indexOf('OTHERS:') == 0 ? status.substring(7) : '');
			var base = status && status.indexOf('OTHERS') == 0 ? 'Others' : status || '';
			return m ? (base ? base + ': ' + m : m) : base;
		},
		parseShipmentPayment(shipment) {
			var s = shipment.status;
			var t = s ? s.replace(/\s/g, '') : '';
			if (!s) {
				this.$set(shipment, 'payment_sel', '');
				this.$set(shipment, 'payment_memo', '');
			} else if (s == 'PAID' || t == '지급완료') {
				this.$set(shipment, 'payment_sel', 'PAID');
				this.$set(shipment, 'payment_memo', '');
			} else if (s == 'UNPAID' || t == '미지급') {
				this.$set(shipment, 'payment_sel', 'UNPAID');
				this.$set(shipment, 'payment_memo', '');
			} else if (s.indexOf('OTHERS') == 0) {
				this.$set(shipment, 'payment_sel', 'OTHERS');
				this.$set(shipment, 'payment_memo', s.length > 7 ? s.substring(7) : '');
			} else {
				this.$set(shipment, 'payment_sel', 'OTHERS');
				this.$set(shipment, 'payment_memo', s);
			}
			this.$set(shipment, 'payment_memo', shipment.status_memo || (s && s.indexOf('OTHERS:') == 0 ? s.substring(7) : ''));
		},
		parseShipmentCbpDuty(shipment) {
			var s = shipment.cbp_duty_status;
			var memo = shipment.cbp_duty_memo || (s && s.indexOf('OTHERS:') == 0 ? s.substring(7) : '');
			if (!s) {
				this.$set(shipment, 'cbp_duty_sel', '');
			} else if (s == 'COMPLETED') {
				this.$set(shipment, 'cbp_duty_sel', 'COMPLETED');
			} else {
				this.$set(shipment, 'cbp_duty_sel', 'OTHERS');
			}
			this.$set(shipment, 'cbp_duty_memo', memo);
		},
		parseShipmentShippingCost(shipment) {
			var s = shipment.shipping_cost_status;
			var memo = shipment.shipping_cost_memo || (s && s.indexOf('OTHERS:') == 0 ? s.substring(7) : '');
			if (!s) {
				this.$set(shipment, 'shipping_cost_sel', '');
			} else if (s == 'COMPLETED') {
				this.$set(shipment, 'shipping_cost_sel', 'COMPLETED');
			} else if (s == 'UNPAID') {
				this.$set(shipment, 'shipping_cost_sel', 'UNPAID');
			} else {
				this.$set(shipment, 'shipping_cost_sel', 'OTHERS');
			}
			this.$set(shipment, 'shipping_cost_memo', memo);
		},
		landedCost(shipment) {
			var a = Number(shipment.received_amount) || 0;
			var b = Number(shipment.cbp_duty) || 0;
			var c = Number(shipment.shipping_cost) || 0;
			return a + b + c;
		},
		async updateStatus(shipment) {
			if (!this.modifiable) return;

			if (this.user.company_id == 'hairplus') {
				if (shipment.payment_sel == 'OTHERS') {
					shipment.status = 'OTHERS';
				} else if (shipment.payment_sel == 'PAID' || shipment.payment_sel == 'UNPAID') {
					shipment.status = shipment.payment_sel;
				} else {
					shipment.status = null;
				}
				shipment.status_memo = shipment.payment_memo || null;
			}

			const { data } = await apiUpdateShipmentStatus(shipment);

			if (data.result) {
				this.$toast.success('Saved successfully');
				//console.log(this.backUri);
			} else {
				this.$toast.error(data.msg);
			}
		},
		async updateCbpDuty(shipment) {
			if (!this.modifiable) return;

			if (shipment.cbp_duty_sel == 'OTHERS') {
				shipment.cbp_duty_status = 'OTHERS';
			} else if (shipment.cbp_duty_sel == 'COMPLETED') {
				shipment.cbp_duty_status = 'COMPLETED';
			} else {
				shipment.cbp_duty_status = null;
			}
			shipment.cbp_duty_memo = shipment.cbp_duty_memo || null;

			if (shipment.cbp_duty === '' || shipment.cbp_duty === undefined) shipment.cbp_duty = null;

			const { data } = await apiUpdateShipmentCbpDuty(shipment);

			if (data.result) {
				this.$toast.success('Saved successfully');
			} else {
				this.$toast.error(data.msg);
			}
		},
		async updateShippingCost(shipment) {
			if (!this.modifiable) return;

			if (shipment.shipping_cost_sel == 'OTHERS') {
				shipment.shipping_cost_status = 'OTHERS';
			} else if (shipment.shipping_cost_sel == 'COMPLETED') {
				shipment.shipping_cost_status = 'COMPLETED';
			} else if (shipment.shipping_cost_sel == 'UNPAID') {
				shipment.shipping_cost_status = 'UNPAID';
			} else {
				shipment.shipping_cost_status = null;
			}
			shipment.shipping_cost_memo = shipment.shipping_cost_memo || null;

			if (shipment.shipping_cost === '' || shipment.shipping_cost === undefined) shipment.shipping_cost = null;

			const { data } = await apiUpdateShipmentShippingCost(shipment);

			if (data.result) {
				this.$toast.success('Saved successfully');
			} else {
				this.$toast.error(data.msg);
			}
		},
		async updateArrivalDate(shipment) {
			if (!this.modifiable) return;

			const { data } = await apiUpdateShipmentArrivalDate(shipment);

			if (data.result) {
				this.$toast.success('Saved successfully');
				//console.log(this.backUri);
			} else {
				this.$toast.error(data.msg);
			}
		},
		async updateClosedYnBatch(closed_yn) {
			if (!this.modifiable) return;

			const sh_nos = this.shipments.filter(s => this.selected_sh_no.includes(s.sh_no)).map(s => s.sh_no);
			if (sh_nos.length == 0) {
				this.$toast.error('No shipment(s) selected.');
				return;
			}

			const action = closed_yn == 'Y' ? 'close' : 'activate';
			if (!confirm('Are you sure to ' + action + ' the selected ' + sh_nos.length + ' shipment(s)?')) return;

			const { data } = await apiUpdateShipmentClosedYnBatch({ sh_nos: sh_nos, closed_yn: closed_yn });

			if (data.result) {
				this.$toast.success('Updated successfully');
				this.selected_sh_no = [];
				this.checked = false;
				await this.selectShipments();
			} else {
				this.$toast.error(data.msg || 'Failed');
			}
		},
		async excel() {
			const { data } = await apiFindShipmentList(objectToFormData({ sh_nos: this.selected_sh_no }));

			const reportTemplate = await apiGetReportTemplate('ShipmentItem', reportMrtUrl('ShipmentItem'));
			const report = new Report(reportTemplate, data, 'ShipmentItem');
			exportFile(report, 'excel');
		},
		// #3312 현재 입력값의 검색 조건(정렬 포함, paging 제외). 목록 조회·Excel·검색 스냅샷이 같은 조건을 쓴다.
		searchCondition() {
			return {
				sort_key: this.sort_key,
				sort_direction: this.sort_direction,

				received_date_from: this.received_date_from,
				received_date_to: this.received_date_to,
				app_date_from: this.app_date_from,
				app_date_to: this.app_date_to,
				vendor_code: this.vendor_code,
				closed_yn: this.closed_yn,
				received_yn: this.received_yn,
				payment_status: this.payment_status,
				cbp_duty_status: this.cbp_duty_status,
				shipping_cost_status: this.shipping_cost_status,
				keyword: this.keyword,
				class_code: this.itemClass,
				carton_from: this.carton_from || null,
				carton_to: this.carton_to || null,
				landed_cost_from: this.landed_cost_from || null,
				landed_cost_to: this.landed_cost_to || null,
			};
		},
		// #3312 Excel 과 Sheet 가 같은 전체(paging 없음) 조회 파라미터를 쓴다.
		excelListParam(condition) {
			return { paging_yn: 'N', ...condition, from_shipment_main: true };
		},
		// #3312 Excel 과 Sheet 가 같은 표시값 가공(Closed 라벨, hairplus 상태 라벨·Landed Cost)을 쓴다.
		excelListRows(list) {
			var vm = this;
			list.forEach(s => {
				s.closed_label = s.closed_yn == 'Y' ? 'Closed' : 'Active';
				if (vm.user.company_id == 'hairplus') {
					s.payment_status_label = vm.paymentStatusLabel(s.status, s.status_memo);
					s.cbp_duty_status_label = vm.statusMemoLabel(s.cbp_duty_status, s.cbp_duty_memo);
					s.shipping_cost_status_label = vm.statusMemoLabel(s.shipping_cost_status, s.shipping_cost_memo);
					s.landed_cost = vm.landedCost(s);
				}
			});
			return list;
		},
		// #3312 Excel 과 Sheet 가 같은 회사별 열 정의를 쓴다.
		excelListHeaders() {
			var headers = [
				{ key: 'sh_dn', name: 'Sh No', width: 15, dataType: defaultDataType.string },
				...(this.user.company_id == 'hairplus' ? [{ key: 'price_basis', name: 'Price basis', width: 15, dataType: defaultDataType.string }] : []),
				{ key: 'application_date', name: 'App Date', width: 12, dataType: defaultDataType.string },
				{ key: 'vendor_code', name: 'Vendor Code', width: 12, dataType: defaultDataType.string },
			];
			if (this.user.company_id != 'newjigu') headers.push({ key: 'lc_no', name: 'LC No', width: 15, dataType: defaultDataType.string });
			headers.push({ key: 'shipment_date', name: 'Ship Date', width: 12, dataType: defaultDataType.string });
			headers.push({ key: 'arrival_date', name: 'Arr. / ETA Date', width: 14, dataType: defaultDataType.string });
			if (this.user.company_id == 'hairplus') {
				headers.push({ key: 'carton', name: 'Carton', width: 8, dataType: defaultDataType.number });
				headers.push({ key: 'total_quantity', name: 'Quantity', width: 10, dataType: defaultDataType.number });
				headers.push({ key: 'total_amount', name: 'Amount', width: 12, dataType: defaultDataType.currency });
				headers.push({ key: 'received_date', name: 'Rcvd Date', width: 12, dataType: defaultDataType.string });
				headers.push({ key: 'closed_label', name: 'Closed', width: 10, dataType: defaultDataType.string });
				headers.push({ key: 'received_quantity', name: 'Rcvd Qty', width: 10, dataType: defaultDataType.number });
				headers.push({ key: 'received_amount', name: 'Rcvd Amt', width: 12, dataType: defaultDataType.currency });
				headers.push({ key: 'payment_status_label', name: 'Status', width: 18, dataType: defaultDataType.string });
				headers.push({ key: 'cbp_duty', name: 'CBP Tariff', width: 12, dataType: defaultDataType.number });
				headers.push({ key: 'cbp_duty_status_label', name: 'CBP Tariff Status', width: 18, dataType: defaultDataType.string });
				headers.push({ key: 'shipping_cost', name: 'Shipping Cost', width: 12, dataType: defaultDataType.number });
				headers.push({ key: 'shipping_cost_status_label', name: 'Shipping Cost Status', width: 18, dataType: defaultDataType.string });
				headers.push({ key: 'landed_cost', name: 'Landed Cost', width: 14, dataType: defaultDataType.currency });
				headers.push({ key: 'description', name: 'Description', width: 30, dataType: defaultDataType.string });
			} else {
				headers.push({ key: 'status', name: 'Status', width: 18, dataType: defaultDataType.string });
				headers.push({ key: 'carton', name: 'Carton', width: 8, dataType: defaultDataType.number });
				headers.push({ key: 'total_quantity', name: 'Quantity', width: 10, dataType: defaultDataType.number });
				headers.push({ key: 'total_amount', name: 'Amount', width: 12, dataType: defaultDataType.currency });
				headers.push({ key: 'received_date', name: 'Rcvd Date', width: 12, dataType: defaultDataType.string });
				if (this.user.company_id != 'newjigu') {
					headers.push({ key: 'received_quantity', name: 'Rcvd Qty', width: 10, dataType: defaultDataType.number });
					headers.push({ key: 'received_amount', name: 'Rcvd Amt', width: 12, dataType: defaultDataType.currency });
					headers.push({ key: 'vendor_name', name: 'Vendor Name', width: 25, dataType: defaultDataType.string });
				} else {
					headers.push({ key: 'classes', name: this.headers.class + ' Code', width: 25, dataType: defaultDataType.string });
					headers.push({ key: 'pos', name: 'PO #s', width: 25, dataType: defaultDataType.string });
				}
				headers.push({ key: 'closed_label', name: 'Closed', width: 10, dataType: defaultDataType.string });
				if (this.user.company_id == 'arkin') {
					headers.push({ key: 'pos', name: 'PO No', width: 25, dataType: defaultDataType.string });
				} else {
					headers.push({ key: 'description', name: 'Description', width: 30, dataType: defaultDataType.string });
				}
			}
			return headers;
		},
		async excelList() {
			const { data } = await apiSelectShipmentList(this.excelListParam(this.searchCondition()));

			var list = data.shipmentList || [];

			if (list.length > 50000) {
				this.$toast.error("Rows Over 50000 Can't Convert into Excel.");
				return;
			}

			this.excelListRows(list);

			exportDataExcel(list, this.excelListHeaders(), 'SHIPMENT_LIST');
		},
		// #3312 Sheet: 마지막 성공 검색 조건으로 전체 조회해 Excel 과 같은 열 + 헤더 아래 합계 행(Carton 'total', 수량·금액 합)을 클립보드 복사 팝업으로 연다.
		async sheet() {
			if (!this.sheet_param) {
				this.$toast.error('Please search first');
				return false;
			}
			const { data } = await apiSelectShipmentList(this.excelListParam(this.sheet_param));
			const rows = data.shipmentList || [];
			if (rows.length > 50000) {
				this.$toast.error("Rows Over 50000 Can't Convert into Excel.");
				return false;
			}
			this.excelListRows(rows);
			this.sheet_popup = {
				title: 'Shipment (Sheet)',
				headers: this.excelListHeaders(),
				rows,
				options: {
					total_row: {
						carton: 'total',
						total_quantity: sumColumn(rows, 'total_quantity', 3),
						total_amount: sumColumn(rows, 'total_amount'),
						received_quantity: sumColumn(rows, 'received_quantity', 3),
						received_amount: sumColumn(rows, 'received_amount'),
					},
				},
			};
		},
		sortMark: function(sort_key) {
			if (this.sort_key == sort_key) return this.sort_direction == 'ASC' ? '▲' : '▼';
			else return null;
		},
		sort(sort_key) {
			if (this.sort_key == sort_key) {
				this.sort_direction = this.sort_direction == 'ASC' ? 'DESC' : 'ASC';
			} else {
				this.sort_key = sort_key;
				this.sort_direction = 'ASC';
			}
			this.selectShipments();
			//console.log(sort_key);
		},
		selectShipment(shipment) {
			this.$router.push({ name: 'shipmentDetail', params: { mode: 'detail' }, query: { backUri: this.uri, sh_no: shipment.sh_no } });
		},
		gotoPage(pageNo) {
			this.page_no = pageNo;
			this.selectShipments(pageNo);
		},
		setPartner(partner) {
			this.vendor_code = partner.code;
			this.search();
		},
		selectPartner() {
			this.modalName = 'PartnerSelect';
			this.showModal = true;
		},
		closeModal() {
			this.showModal = false;
		},
		reset() {
			this.received_date_from = null;
			this.received_date_to = null;
			this.app_date_from = this.user.company_id == 'he' ? daysAgo(365) : daysAgo(6);
			this.app_date_to = today();
			this.closed_yn = 'A';
			this.payment_status = 'A';
			this.cbp_duty_status = 'A';
			this.shipping_cost_status = 'A';
			this.vendor_code = null;
			this.keyword = null;
			this.itemClass = null;
			this.carton_from = null;
			this.carton_to = null;
			this.landed_cost_from = null;
			this.landed_cost_to = null;

			//this.selectInvoices();
			// this.dept_code = null;
		},
		allClick() {
			const vm = this;
			if (this.checked) {
				this.shipments.forEach(sh => {
					vm.selected_sh_no.push(sh.sh_no);
				});
			} else {
				vm.selected_sh_no = [];
			}
		},
		async search() {
			await this.selectShipments();
			if (this.shipments.length == 1 && this.keyword) this.$router.push({ name: 'shipmentDetail', params: { mode: 'detail' }, query: { backUri: this.uri, sh_no: this.shipments[0].sh_no } });
		},
		async selectShipments(pageNo) {
			if (pageNo) this.page_no = pageNo;
			else this.page_no = 1;

			// #3312 조회에 보낸 조건을 그대로 스냅샷으로 남겨 Sheet 가 화면 결과와 같은 조건으로 전체 조회한다.
			const condition = this.searchCondition();
			const { data } = await apiSelectShipmentList({
				paging_yn: this.paging_yn,
				page_size: this.page_size,
				page_no: this.page_no,
				start_index: this.page_size * (this.page_no - 1),
				...condition,

				from_shipment_main: true,
			});

			//console.log(data);

			this.sheet_param = condition;
			this.shipments = data.shipmentList;
			if (this.user.company_id == 'hairplus' && this.shipments) {
				this.shipments.forEach(s => {
					this.parseShipmentPayment(s);
					this.parseShipmentCbpDuty(s);
					this.parseShipmentShippingCost(s);
				});
			}
			//console.log(this.purchases);
			//this.list_count = data.list_count;
			this.shipments_sum = data.shipmentsSum;

			this.$refs.paging.setPage(this.page_no, this.page_size, this.shipments_sum.list_count);

			var uri = '/purchase/shipment_main?page_no=' + this.page_no;
			if (this.sort_key) uri += '&sort_key=' + this.sort_key;
			if (this.sort_direction) uri += '&sort_direction=' + this.sort_direction;
			if (this.keyword) uri += '&keyword=' + this.keyword;
			if (this.closed_yn) uri += '&closed_yn=' + this.closed_yn;
			if (this.received_yn) uri += '&received_yn=' + this.received_yn;
			if (this.payment_status) uri += '&payment_status=' + this.payment_status;
			if (this.cbp_duty_status) uri += '&cbp_duty_status=' + this.cbp_duty_status;
			if (this.shipping_cost_status) uri += '&shipping_cost_status=' + this.shipping_cost_status;
			if (this.received_date_from) uri += '&received_date_from=' + this.received_date_from;
			if (this.received_date_to) uri += '&received_date_to=' + this.received_date_to;
			if (this.app_date_from) uri += '&app_date_from=' + this.app_date_from;
			if (this.app_date_to) uri += '&app_date_to=' + this.app_date_to;
			if (this.vendor_code) uri += '&vendor_code=' + this.vendor_code;
			if (this.itemClass) uri += '&itemClass=' + this.itemClass;
			if (this.carton_from) uri += '&carton_from=' + this.carton_from;
			if (this.carton_to) uri += '&carton_to=' + this.carton_to;
			if (this.landed_cost_from) uri += '&landed_cost_from=' + this.landed_cost_from;
			if (this.landed_cost_to) uri += '&landed_cost_to=' + this.landed_cost_to;
			////this.$router.replace(uri).catch(err => err);
			this.uri = uri;
			window.history.pushState({}, null, uri);
		},
		gotoPartner(code) {
			//console.log(code);
			this.$router.push({ name: 'partnerDetail', params: { mode: 'detail' }, query: { backUri: this.uri, code: code } });
		},
		async index() {
			//const { data } = await apiIndex();
			//this.salesGroups = data.salesGroupList;
			//this.states = data.stateList;
		},
		async init() {
			//await this.index();

			if (this.user.company_id == 'he') this.app_date_from = daysAgo(365);

			if (this.$route.query.sort_key) this.sort_key = this.$route.query.sort_key;
			if (this.$route.query.sort_direction) this.sort_direction = this.$route.query.sort_direction;
			if (this.$route.query.keyword) this.keyword = this.$route.query.keyword;
			if (this.$route.query.closed_yn) this.closed_yn = this.$route.query.closed_yn;
			if (this.$route.query.received_yn) this.received_yn = this.$route.query.received_yn;
			if (this.$route.query.payment_status) this.payment_status = this.$route.query.payment_status;
			if (this.$route.query.cbp_duty_status) this.cbp_duty_status = this.$route.query.cbp_duty_status;
			if (this.$route.query.shipping_cost_status) this.shipping_cost_status = this.$route.query.shipping_cost_status;
			if (this.$route.query.received_date_from) this.received_date_from = this.$route.query.received_date_from;
			if (this.$route.query.received_date_to) this.received_date_to = this.$route.query.received_date_to;
			if (this.$route.query.app_date_from) this.app_date_from = this.$route.query.app_date_from;
			if (this.$route.query.app_date_to) this.app_date_to = this.$route.query.app_date_to;
			if (this.$route.query.vendor_code) this.vendor_code = this.$route.query.vendor_code;
			if (this.$route.query.itemClass) this.itemClass = this.$route.query.itemClass;
			if (this.$route.query.carton_from) this.carton_from = this.$route.query.carton_from;
			if (this.$route.query.carton_to) this.carton_to = this.$route.query.carton_to;
			if (this.$route.query.landed_cost_from) this.landed_cost_from = this.$route.query.landed_cost_from;
			if (this.$route.query.landed_cost_to) this.landed_cost_to = this.$route.query.landed_cost_to;
			this.page_size = this.$store.getters['getDefaultPageSize'];

			await this.selectShipments(this.$route.query.page_no);
		},
	},
	created() {
		this.$store.commit('setSideIndex', 2);
		this.$store.commit('setSelectedMenu', 'nav_li_shipment_main');
		this.$store.commit('setSubTitle', 'Purchase -> Shipment');

		this.init();
	},
	mounted() {
		inputSelectOnClick();
	},
};
</script>

<style scoped>
.desc_clamp {
	display: -webkit-box;
	-webkit-line-clamp: 2;
	line-clamp: 2;
	-webkit-box-orient: vertical;
	overflow: hidden;
	word-break: break-word;
	line-height: 16px;
	max-height: 32px;
	white-space: normal;
}
.cbp_cell,
.nowrap_cell {
	white-space: nowrap;
}
.cbp_cell .tbl_int,
.cbp_cell .tbl_select {
	margin-right: 1px;
}
.red_sel {
	color: red;
}
</style>
